/**
 * Feature switches for the navigation bars.
 *
 * These are build-time constants, not runtime toggles: nothing here is meant to
 * vary per user or per environment. They exist so a control that is designed
 * but not yet wired up can be hidden from one place instead of being deleted
 * and rebuilt later.
 */

/**
 * Notification centre. The bell is in the Figma header on both desktop and
 * responsive, but there is no notification feature behind it yet, so it is
 * hidden rather than shipped as a control that does nothing.
 *
 * Flip to `true` once the notification centre exists — the markup, sizing and
 * `navigation_item_clicked` tracking are already in place in both headers.
 */
export var SHOW_NOTIFICATION_CENTER = false;